import { domainConfig } from 'utils/domainConfig';

import { Address, Client, Email, Phone, User } from './user.model';
import { AddressDTO, EmailDTO, PhoneDTO } from '../client/client.model';

const { isRo } = domainConfig;

export const mapClientToDeprecated = (client: Client): User => ({
  ...client,
  id: client.clientId,
  lastName: client.surname,
  email: client.userAccountEmail,
  peselGender: client.gender
});
export const mapAddressDTOToAddress = (dto: AddressDTO): Address => {
  const common = {
    addressId: dto.id,
    addressType: dto.type,
    apartmentNumber: dto.flatNumber,
    buildingNumber: dto.buildingNumber,
    street: dto.street,
    city: dto.city,
    countryCode: dto.countryCode?.code ?? null,
    country: dto.countryCode?.name ?? null
  };

  if (isRo)
    return {
      ...common,
      kind: 'RO',
      county: dto.county,
      entrance: dto.entrance,
      floor: dto.floor,
      streetNumber: dto.streetNumber
    };
  return {
    ...common,
    kind: 'PL',
    postalCode: dto.zipCode,
    postCity: dto.post
  };
};

export const mapPhoneDTOToPhone = (dto: PhoneDTO): Phone => ({
  phoneNumberId: dto.id,
  phoneNumber: dto.number,
  phoneNumberCodePrefix: dto.prefix?.prefix ?? null,
  phoneNumberCountryCode: dto.prefix?.country ?? null,
  phoneNumberType: dto.type
});

export const mapEmailDTOToEmail = (dto: EmailDTO): Email => ({
  emailAddressId: dto.id,
  emailAddress: dto.address,
  emailAddressType: dto.type,
  loginEmail: dto.usedAsLogin
});
